// This file was auto generated by resource-sync tools.

import ar_shop_set_web from './ar/shop_set_web.json';
import en_shop_set_web from './en/shop_set_web.json';
import ptBR_shop_set_web from './pt-BR/shop_set_web.json';
import zh_shop_set_web from './zh/shop_set_web.json';
import zhHK_shop_set_web from './zh-HK/shop_set_web.json';
import ar_finance_bankcardEdit from './ar/finance_bankcardEdit.json';
import en_finance_bankcardEdit from './en/finance_bankcardEdit.json';
import ptBR_finance_bankcardEdit from './pt-BR/finance_bankcardEdit.json';
import zh_finance_bankcardEdit from './zh/finance_bankcardEdit.json';
import zhHK_finance_bankcardEdit from './zh-HK/finance_bankcardEdit.json';
import ar_message_center from './ar/message_center.json';
import en_message_center from './en/message_center.json';
import ptBR_message_center from './pt-BR/message_center.json';
import zh_message_center from './zh/message_center.json';
import zhHK_message_center from './zh-HK/message_center.json';
import ar_Merchant_open_time_web_v1 from './ar/Merchant_open_time_web_v1.json';
import en_Merchant_open_time_web_v1 from './en/Merchant_open_time_web_v1.json';
import ptBR_Merchant_open_time_web_v1 from './pt-BR/Merchant_open_time_web_v1.json';
import zh_Merchant_open_time_web_v1 from './zh/Merchant_open_time_web_v1.json';
import zhHK_Merchant_open_time_web_v1 from './zh-HK/Merchant_open_time_web_v1.json';
import ar_account_web from './ar/account_web.json';
import en_account_web from './en/account_web.json';
import ptBR_account_web from './pt-BR/account_web.json';
import zh_account_web from './zh/account_web.json';
import zhHK_account_web from './zh-HK/account_web.json';
import ar_business_status from './ar/business_status.json';
import en_business_status from './en/business_status.json';
import ptBR_business_status from './pt-BR/business_status.json';
import zh_business_status from './zh/business_status.json';
import zhHK_business_status from './zh-HK/business_status.json';
import ar_customer_review_web from './ar/customer_review_web.json';
import en_customer_review_web from './en/customer_review_web.json';
import ptBR_customer_review_web from './pt-BR/customer_review_web.json';
import zh_customer_review_web from './zh/customer_review_web.json';
import zhHK_customer_review_web from './zh-HK/customer_review_web.json';
import ar_Healthiness_level from './ar/Healthiness_level.json';
import en_Healthiness_level from './en/Healthiness_level.json';
import ptBR_Healthiness_level from './pt-BR/Healthiness_level.json';
import zh_Healthiness_level from './zh/Healthiness_level.json';
import zhHK_Healthiness_level from './zh-HK/Healthiness_level.json';
import ar_Native_BasicServices from './ar/Native_BasicServices.json';
import en_Native_BasicServices from './en/Native_BasicServices.json';
import ptBR_Native_BasicServices from './pt-BR/Native_BasicServices.json';
import zh_Native_BasicServices from './zh/Native_BasicServices.json';
import zhHK_Native_BasicServices from './zh-HK/Native_BasicServices.json';
import ar_B_APP from './ar/B_APP.json';
import en_B_APP from './en/B_APP.json';
import ptBR_B_APP from './pt-BR/B_APP.json';
import zh_B_APP from './zh/B_APP.json';
import zhHK_B_APP from './zh-HK/B_APP.json';
import ar_pos_order_process from './ar/pos_order_process.json';
import en_pos_order_process from './en/pos_order_process.json';
import ptBR_pos_order_process from './pt-BR/pos_order_process.json';
import zh_pos_order_process from './zh/pos_order_process.json';
import zhHK_pos_order_process from './zh-HK/pos_order_process.json';
import ar_b_web_settle from './ar/b_web_settle.json';
import en_b_web_settle from './en/b_web_settle.json';
import ptBR_b_web_settle from './pt-BR/b_web_settle.json';
import zh_b_web_settle from './zh/b_web_settle.json';
import zhHK_b_web_settle from './zh-HK/b_web_settle.json';
import ar_m_web_settle from './ar/m_web_settle.json';
import en_m_web_settle from './en/m_web_settle.json';
import ptBR_m_web_settle from './pt-BR/m_web_settle.json';
import zh_m_web_settle from './zh/m_web_settle.json';
import zhHK_m_web_settle from './zh-HK/m_web_settle.json';
import ar_web_merchants_enter from './ar/web_merchants_enter.json';
import en_web_merchants_enter from './en/web_merchants_enter.json';
import ptBR_web_merchants_enter from './pt-BR/web_merchants_enter.json';
import ur_web_merchants_enter from './ur/web_merchants_enter.json';
import zh_web_merchants_enter from './zh/web_merchants_enter.json';
import zhHK_web_merchants_enter from './zh-HK/web_merchants_enter.json';
import ar_keeta_design from './ar/keeta_design.json';
import en_keeta_design from './en/keeta_design.json';
import ptBR_keeta_design from './pt-BR/keeta_design.json';
import zh_keeta_design from './zh/keeta_design.json';
import zhHK_keeta_design from './zh-HK/keeta_design.json';


const resources = {
    'namespaces': 
    [{"localeInfos":[{"locale":"ar","version":537},{"locale":"en","version":603},{"locale":"pt-BR","version":333},{"locale":"zh","version":532},{"locale":"zh-HK","version":432}],"i18nConfig":{"apiKey":"dd709595d1344094ae219064ab53f28b","projectId":5,"namespaceId":"dtu0qybsds","namespaceName":"shop_set_web"}},{"localeInfos":[{"locale":"ar","version":32},{"locale":"en","version":35},{"locale":"pt-BR","version":9},{"locale":"zh","version":34},{"locale":"zh-HK","version":30}],"i18nConfig":{"apiKey":"dd709595d1344094ae219064ab53f28b","projectId":5,"namespaceId":"a175mxahwh","namespaceName":"finance_bankcardEdit"}},{"localeInfos":[{"locale":"ar","version":26},{"locale":"en","version":34},{"locale":"pt-BR","version":14},{"locale":"zh","version":30},{"locale":"zh-HK","version":31}],"i18nConfig":{"apiKey":"dd709595d1344094ae219064ab53f28b","projectId":5,"namespaceId":"59raukmtno","namespaceName":"message_center"}},{"localeInfos":[{"locale":"ar","version":20},{"locale":"en","version":32},{"locale":"pt-BR","version":13},{"locale":"zh","version":23},{"locale":"zh-HK","version":19}],"i18nConfig":{"apiKey":"dd709595d1344094ae219064ab53f28b","projectId":5,"namespaceId":"clhluivvfp","namespaceName":"Merchant_open_time_web_v1"}},{"localeInfos":[{"locale":"ar","version":76},{"locale":"en","version":111},{"locale":"pt-BR","version":64},{"locale":"zh","version":103},{"locale":"zh-HK","version":75}],"i18nConfig":{"apiKey":"dd709595d1344094ae219064ab53f28b","projectId":5,"namespaceId":"olipmd4ssu","namespaceName":"account_web"}},{"localeInfos":[{"locale":"ar","version":496},{"locale":"en","version":592},{"locale":"pt-BR","version":355},{"locale":"zh","version":550},{"locale":"zh-HK","version":394}],"i18nConfig":{"apiKey":"dd709595d1344094ae219064ab53f28b","projectId":5,"namespaceId":"wfplz9bnb3","namespaceName":"business_status"}},{"localeInfos":[{"locale":"ar","version":67},{"locale":"en","version":68},{"locale":"pt-BR","version":37},{"locale":"zh","version":76},{"locale":"zh-HK","version":63}],"i18nConfig":{"apiKey":"dd709595d1344094ae219064ab53f28b","projectId":"5","namespaceId":"6g7sxko2dx","namespaceName":"customer_review_web"}},{"localeInfos":[{"locale":"ar","version":36},{"locale":"en","version":68},{"locale":"pt-BR","version":7},{"locale":"zh","version":90},{"locale":"zh-HK","version":87}],"i18nConfig":{"apiKey":"dd709595d1344094ae219064ab53f28b","projectId":5,"namespaceId":"qcqemtsfuh","namespaceName":"Healthiness_level"}},{"localeInfos":[{"locale":"ar","version":26},{"locale":"en","version":29},{"locale":"pt-BR","version":7},{"locale":"zh","version":26},{"locale":"zh-HK","version":25}],"i18nConfig":{"apiKey":"dd709595d1344094ae219064ab53f28b","projectId":5,"namespaceId":"utjoqvl3cc","namespaceName":"Native_BasicServices"}},{"localeInfos":[{"locale":"ar","version":496},{"locale":"en","version":592},{"locale":"pt-BR","version":355},{"locale":"zh","version":550},{"locale":"zh-HK","version":394}],"i18nConfig":{"apiKey":"dd709595d1344094ae219064ab53f28b","projectId":"5","namespaceId":"wfplz9bnb3","namespaceName":"B_APP"}},{"localeInfos":[{"locale":"ar","version":878},{"locale":"en","version":894},{"locale":"pt-BR","version":293},{"locale":"zh","version":921},{"locale":"zh-HK","version":760}],"i18nConfig":{"apiKey":"dd709595d1344094ae219064ab53f28b","projectId":5,"namespaceId":"o082lntk5e","namespaceName":"pos_order_process"}},{"localeInfos":[{"locale":"ar","version":27},{"locale":"en","version":63},{"locale":"pt-BR","version":75},{"locale":"zh","version":97},{"locale":"zh-HK","version":24}],"i18nConfig":{"apiKey":"dd709595d1344094ae219064ab53f28b","projectId":5,"namespaceId":"vj9dug7rtn","namespaceName":"b_web_settle"}},{"localeInfos":[{"locale":"ar","version":3},{"locale":"en","version":3},{"locale":"pt-BR","version":3},{"locale":"zh","version":3},{"locale":"zh-HK","version":3}],"i18nConfig":{"apiKey":"c8a8b802de0447359433a0aaa8e51bf8","projectId":6,"namespaceId":"7pqvwxwxek","namespaceName":"m_web_settle"}},{"localeInfos":[{"locale":"ar","version":2257},{"locale":"en","version":2555},{"locale":"pt-BR","version":1066},{"locale":"ur","version":96},{"locale":"zh","version":2963},{"locale":"zh-HK","version":2256}],"i18nConfig":{"apiKey":"c8a8b802de0447359433a0aaa8e51bf8","projectId":6,"namespaceId":"iqn5xcqzxb","namespaceName":"web_merchants_enter"}},{"localeInfos":[{"locale":"ar","version":19},{"locale":"en","version":17},{"locale":"pt-BR","version":20},{"locale":"zh","version":17},{"locale":"zh-HK","version":18}],"i18nConfig":{"apiKey":"dd709595d1344094ae219064ab53f28b","projectId":5,"namespaceId":"ex3ebkdixv","namespaceName":"keeta_design"}}],
    'ar': {
        shop_set_web: ar_shop_set_web,
        finance_bankcardEdit: ar_finance_bankcardEdit,
        message_center: ar_message_center,
        Merchant_open_time_web_v1: ar_Merchant_open_time_web_v1,
        account_web: ar_account_web,
        business_status: ar_business_status,
        customer_review_web: ar_customer_review_web,
        Healthiness_level: ar_Healthiness_level,
        Native_BasicServices: ar_Native_BasicServices,
        B_APP: ar_B_APP,
        pos_order_process: ar_pos_order_process,
        b_web_settle: ar_b_web_settle,
        m_web_settle: ar_m_web_settle,
        web_merchants_enter: ar_web_merchants_enter,
        keeta_design: ar_keeta_design
    },
    'en': {
        shop_set_web: en_shop_set_web,
        finance_bankcardEdit: en_finance_bankcardEdit,
        message_center: en_message_center,
        Merchant_open_time_web_v1: en_Merchant_open_time_web_v1,
        account_web: en_account_web,
        business_status: en_business_status,
        customer_review_web: en_customer_review_web,
        Healthiness_level: en_Healthiness_level,
        Native_BasicServices: en_Native_BasicServices,
        B_APP: en_B_APP,
        pos_order_process: en_pos_order_process,
        b_web_settle: en_b_web_settle,
        m_web_settle: en_m_web_settle,
        web_merchants_enter: en_web_merchants_enter,
        keeta_design: en_keeta_design
    },
    'pt-BR': {
        shop_set_web: ptBR_shop_set_web,
        finance_bankcardEdit: ptBR_finance_bankcardEdit,
        message_center: ptBR_message_center,
        Merchant_open_time_web_v1: ptBR_Merchant_open_time_web_v1,
        account_web: ptBR_account_web,
        business_status: ptBR_business_status,
        customer_review_web: ptBR_customer_review_web,
        Healthiness_level: ptBR_Healthiness_level,
        Native_BasicServices: ptBR_Native_BasicServices,
        B_APP: ptBR_B_APP,
        pos_order_process: ptBR_pos_order_process,
        b_web_settle: ptBR_b_web_settle,
        m_web_settle: ptBR_m_web_settle,
        web_merchants_enter: ptBR_web_merchants_enter,
        keeta_design: ptBR_keeta_design
    },
    'zh': {
        shop_set_web: zh_shop_set_web,
        finance_bankcardEdit: zh_finance_bankcardEdit,
        message_center: zh_message_center,
        Merchant_open_time_web_v1: zh_Merchant_open_time_web_v1,
        account_web: zh_account_web,
        business_status: zh_business_status,
        customer_review_web: zh_customer_review_web,
        Healthiness_level: zh_Healthiness_level,
        Native_BasicServices: zh_Native_BasicServices,
        B_APP: zh_B_APP,
        pos_order_process: zh_pos_order_process,
        b_web_settle: zh_b_web_settle,
        m_web_settle: zh_m_web_settle,
        web_merchants_enter: zh_web_merchants_enter,
        keeta_design: zh_keeta_design
    },
    'zh-HK': {
        shop_set_web: zhHK_shop_set_web,
        finance_bankcardEdit: zhHK_finance_bankcardEdit,
        message_center: zhHK_message_center,
        Merchant_open_time_web_v1: zhHK_Merchant_open_time_web_v1,
        account_web: zhHK_account_web,
        business_status: zhHK_business_status,
        customer_review_web: zhHK_customer_review_web,
        Healthiness_level: zhHK_Healthiness_level,
        Native_BasicServices: zhHK_Native_BasicServices,
        B_APP: zhHK_B_APP,
        pos_order_process: zhHK_pos_order_process,
        b_web_settle: zhHK_b_web_settle,
        m_web_settle: zhHK_m_web_settle,
        web_merchants_enter: zhHK_web_merchants_enter,
        keeta_design: zhHK_keeta_design
    },
    'ur': {
        web_merchants_enter: ur_web_merchants_enter
    }
};

export default resources;